import React, { FC } from 'react';
import { SvgType } from '../../types';

export const SquareSvgComponent: FC<SvgType> = ({ color = '#F0F0F4' }) => {
  return (
    <svg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
      <path d='M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z' fill={ color } />
    </svg>
  );
};
